import "./FashionRetailerCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import Spotlight from "./sections/Spotlight";
import Results from "./sections/Results";
import Execution from "./sections/Execution";
import CaseHero from "./sections/CaseHero";
import Calltoaction from "./sections/Calltoaction";
import FashionChallenge from "./sections/FashionChallenge";
import Impact from "./sections/Impact";
import FashionStrategy from "./sections/FashionStrategy";
import Footer from "@/reusable_sections/Footer";
export default function FashionRetailerCaseStudyPage() {
  return <div>
      <Header />
      <Spotlight />
      <Results />
      <Execution />
      <CaseHero />
      <Calltoaction />
      <FashionChallenge />
      <Impact />
      <FashionStrategy />
      <Footer />
    </div>;
}